export default __webpack_public_path__ + "static/media/copper-plate.dd0a99ad.svg";